import { IssuesCount } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import {
	AccessibilitySummaryData,
	createDefaultAccessibilitySummary
} from './accessibilityHelpers';
import {
	calculateAccessibilityScore,
	calculatePeriodData,
	createMetric,
	getAccessibilityStatus
} from './calculationHelpers';

const DEFAULT_SELECTED_PERIOD = 30;

export const transformAccessibilityData = (
	rawData: IssuesCount[],
	selectedPeriod?: number
): AccessibilitySummaryData => {
	if (!rawData || rawData.length === 0) {
		return createDefaultAccessibilitySummary();
	}

	const period = selectedPeriod || DEFAULT_SELECTED_PERIOD;
	const periodData = calculatePeriodData(rawData, period);

	const score = calculateAccessibilityScore();

	return {
		groupedScore: {
			score: Math.round(score),
			status: getAccessibilityStatus(score)
		},
		uniqueIssues: {
			critical: createMetric(periodData.current.latest.critical, periodData.current.first.critical),
			allIssues: createMetric(
				periodData.current.latest.allIssues,
				periodData.current.first.allIssues
			)
		},
		totalIssues: {
			critical: createMetric(periodData.current.critical, periodData.previous.critical),
			allIssues: createMetric(periodData.current.allIssues, periodData.previous.allIssues)
		}
	};
};
